module.exports = __webpack_public_path__ + "img/people22.6442d1b0.png";